import { QueryErrorBoundary, QueryErrorBoundaryProps } from '~/components/Error';

export type BlankErrorBoundaryProps = QueryErrorBoundaryProps;
const Blank = () => null;
export const BlankErrorBoundary = (props: BlankErrorBoundaryProps) => (
  <QueryErrorBoundary {...props} FallbackComponent={Blank} />
);
